import { render, staticRenderFns } from "./FenceAlarm.vue?vue&type=template&id=1f312b18&scoped=true"
import script from "./FenceAlarm.vue?vue&type=script&lang=js"
export * from "./FenceAlarm.vue?vue&type=script&lang=js"
import style0 from "./FenceAlarm.vue?vue&type=style&index=0&id=1f312b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f312b18",
  null
  
)

export default component.exports